import { ReactElement } from 'react'

import LeaveOfAbsencesOverviewFilterContainer from '../../../containers/@filters/LeaveOfAbsencesOverviewFilterContainer/LeaveOfAbsencesOverviewFilterContainer'

const ConnectedLeaveOfAbsencesOverviewFilter = (): ReactElement => (
    <LeaveOfAbsencesOverviewFilterContainer />
)

export default ConnectedLeaveOfAbsencesOverviewFilter
